import script from "./Captain.vue?vue&type=script&setup=true&lang=js"
export * from "./Captain.vue?vue&type=script&setup=true&lang=js"

import "./Captain.vue?vue&type=style&index=0&id=5fcd085f&lang=scss&scoped=true"
import "./Captain.vue?vue&type=style&index=1&id=5fcd085f&lang=scss&scoped=true"
import "./Captain.vue?vue&type=style&index=2&id=5fcd085f&scoped=true&lang=css"
import "./Captain.vue?vue&type=style&index=3&id=5fcd085f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fcd085f"]])

export default __exports__